import styled from '@emotion/styled';

export const InputContainer = styled.div`
	display: flex;
	align-items: center;
	position: relative;

	&.borderless {
		> input:not(:hover):not(:focus) {
			border: 1px solid transparent;
		}
	}

	&.grey {
		> input:not(:hover):not(:focus) {
			border: 1px solid transparent;
			background: var(--background-3);
			color: var(--black);
		}
	}

	&.full-width {
		width: 100%;
	}

	&.expandable {
		> input {
			width: 20rem;
			transition: all 0.3s ease-in-out;
		}

		:hover,
		:active,
		:focus,
		:focus-within {
			> input {
				width: 30rem;
			}
		}
	}

	&.expandable-icon {
		> input {
			width: 0;
			padding: 0 0 0 4rem;
			border: none;
			background: transparent;
			transition: all 0.5s ease-in-out;

			body[dir='rtl'] & {
				padding: 0 4rem 0 0;
			}
		}

		:hover,
		:active,
		:focus,
		:focus-within {
			> input {
				width: 30rem;
				padding: var(--inputPadding) var(--inputPadding) var(--inputPadding) 4rem;
				background-color: var(--table-selected-color);
				border: 1px solid var(--blue);

				body[dir='rtl'] & {
					padding: var(--inputPadding) 4rem var(--inputPadding) var(--inputPadding);
				}
			}
		}
	}

	> input {
		padding: var(--inputPadding) var(--inputPadding) var(--inputPadding) 4rem;

		::placeholder {
			color: var(--black-20);
		}

		body[dir='rtl'] & {
			padding: var(--inputPadding) 4rem var(--inputPadding) var(--inputPadding);
		}
	}

	> .delete-button {
		display: none;
		position: absolute;
		right: 1rem;
		transition: all 0.2s ease-in-out;

		body[dir='rtl'] & {
			right: unset;
			left: 1rem;
		}
	}

	:hover > .delete-button {
		display: flex;
	}
`;

export const LordIconContainer = styled.div`
	position: absolute;

	.lord-icon {
		position: relative;
		left: 1rem;

		body[dir='rtl'] & {
			left: unset;
			right: 1rem;
		}
	}
`;
